// extracted by mini-css-extract-plugin
module.exports = {"nav__container":"core_nav__container__jVY-t","tooltip":"core_tooltip__2FfYI","tag_button":"core_tag_button__2H-1t"};